import React from 'react';
import { useSelector } from 'react-redux';
import { VaAlertSignIn } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

import { CSP_IDS } from '~/platform/user/authentication/constants';
import { signInServiceName } from '~/platform/user/authentication/selectors';
import {
  VerifyIdmeButton,
  VerifyLogingovButton,
  VerifyClearButton,
} from '~/platform/user/authentication/components/VerifyButton';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';

export default function VerifyAlert({ headingLevel = 2, dataTestId }) {
  const csp = useSelector(signInServiceName);
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const clearSigninEnabled = useToggleValue(TOGGLE_NAMES.clearSigninEnabled);

  if (csp === CSP_IDS.MHV) {
    return (
      <VaAlertSignIn
        variant="signInEither"
        visible
        headingLevel={headingLevel}
        data-testid={dataTestId}
      >
        <span slot="IdMeSignInButton">
          <VerifyIdmeButton
            queryParams={{ operation: 'verify_cta_authenticated' }}
          />
        </span>
        <span slot="LoginGovSignInButton">
          <VerifyLogingovButton
            queryParams={{ operation: 'verify_cta_authenticated' }}
          />
        </span>
        {clearSigninEnabled && (
          <span slot="ClearSignInButton">
            <VerifyClearButton
              queryParams={{ operation: 'verify_cta_authenticated' }}
            />
          </span>
        )}
      </VaAlertSignIn>
    );
  }

  const verifyOptionsByCsp = {
    [CSP_IDS.LOGIN_GOV]: {
      variant: 'verifyLoginGov',
      spanSlot: (
        <span slot="LoginGovVerifyButton">
          <VerifyLogingovButton
            queryParams={{ operation: 'verify_cta_authenticated' }}
          />
        </span>
      ),
    },
    ...(clearSigninEnabled && {
      [CSP_IDS.CLEAR]: {
        variant: 'verifyClear',
        spanSlot: (
          <span slot="ClearVerifyButton">
            <VerifyClearButton
              queryParams={{ operation: 'verify_cta_authenticated' }}
            />
          </span>
        ),
      },
    }),
  };

  const { variant, spanSlot } = verifyOptionsByCsp[csp] || {
    variant: 'verifyIdMe',
    spanSlot: (
      <span slot="IdMeVerifyButton">
        <VerifyIdmeButton
          queryParams={{ operation: 'verify_cta_authenticated' }}
        />
      </span>
    ),
  };

  return (
    <VaAlertSignIn
      variant={variant}
      visible
      headingLevel={headingLevel}
      data-testid={dataTestId}
    >
      {spanSlot}
    </VaAlertSignIn>
  );
}
